import React, { useEffect, useState } from "react";
import clsx from 'clsx';
import {
  Card, CardContent, Grid
} from '@material-ui/core';

import { withStyles } from '@material-ui/styles';
import withShowToast from "../../../../../../hocs/with_show_toast.js";
import { compose } from 'redux';

import I18n from "../../../../../../base/i18n.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import MoneyFormatter from "../../../../../../utils/money_formatter.js";
import ShowUserStatisticsUseCase from "../../../../../../use_cases/admin/statistics/users/show_user_statistics_use_case.js";
import { StatisticsUpdateContext } from "../statistics_update_context.js";

const styles = theme => ({
});

const InvestmentStatisticsCard = (props) => {

  const moneyFormat = (value) => {
    return MoneyFormatter.format(value, "0,0[.][00]");
  };

  const isPresent = (value) => {
    return value !== undefined && value !== null;
  };

  const { classes } = props;

  const user = props.user || {};
  const [loading, setLoading] = useState(true);
  const [userStatistics, setUserStatistics] = useState({});

  const { projects: { count: totalProjectsCount } = {} } = userStatistics;
  const { investments: { totalAmountInvestments } = {}} = userStatistics;

  useEffect(() => {
    setLoading(true);
    ShowUserStatisticsUseCase.execute(user.id)
    .then((result) => {
      const { data: { userStatistics } } = result;
      setUserStatistics(userStatistics);
      setLoading(false);
    })
    .catch((result) => {
      setLoading(false)
      props.showServerErrorIfNeed(result);
    })
  }, [props.lastLoad])

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.investment_statistics")}
        </div>
        {
          !loading &&
          <Grid container spacing = { 3 } >
            <Grid item sm = { 6 } >
              <span className = { classes.label } >
                { `${I18n.t("admin.users.user.investment_statistics.projects")}:` }
              </span>
              <span className = { classes.value } >
                { isPresent(totalProjectsCount) ? totalProjectsCount : 0 }
              </span>
            </Grid>
            <Grid item sm = { 6 } >
              <span className = { classes.label } >
                { `${I18n.t("admin.users.user.investment_statistics.total_amount_of_investment")}:` }
              </span>
              <span className = { classes.value } >
                { `${isPresent(totalAmountInvestments) ? moneyFormat(totalAmountInvestments) : ""} ${I18n.t("currency.euro")}` }
              </span>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  );
}

InvestmentStatisticsCard.defaultProps = {
}

const Component = compose(
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...cardStyles(theme),
      ...styles(theme)
    }),
    { withTheme: true }
  ),
  withShowToast
)(InvestmentStatisticsCard);

export default (props) => {
  return (
    <StatisticsUpdateContext.Consumer>
      { context =>
        <Component { ...props }
                   lastLoad = { context.lastLoad } />
      }
    </StatisticsUpdateContext.Consumer>
  )
};
